/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Interviews_AgreedInputs */

const en_admin_statistics_interviews_agreed = /** @type {(inputs: Admin_Statistics_Interviews_AgreedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interviews agreed`)
};

const de_admin_statistics_interviews_agreed = /** @type {(inputs: Admin_Statistics_Interviews_AgreedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereinbarte Gespräche`)
};

/**
* | output |
* | --- |
* | "Interviews agreed" |
*
* @param {Admin_Statistics_Interviews_AgreedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_interviews_agreed = /** @type {((inputs?: Admin_Statistics_Interviews_AgreedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Interviews_AgreedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_interviews_agreed(inputs)
	return en_admin_statistics_interviews_agreed(inputs)
});